module.exports = __webpack_public_path__ + "img/steel-2.3b68174c.jpg";